const importantNotes = [
  {
    type: "note",
    category: [`precon`],
    text: `New Builds typically pay commission calculated on the sale price net of
    GST.`,
  },
  {
    type: "note",
    category: [`precon`],
    text: `Please note that for commissions paid in installments, there will be
    multiple files/sub-trades created by the staff once you upload all your 
    documents into SkySlope. The complete set of documents are found in the file 
    labeled “A”.`,
  },

  {
    type: "note",
    category: [`mls`],
    text: `Please ensure that the commencement and expiry date on your Listing Agreement
    matches the contract start and end date on MLS.`,
  },

  {
    type: "note",
    category: [`fsbo`],
    text: `In addition to your client, it is important to identify the Seller(s) in
    this type of transaction to verify they have authority to sell the
    property.`,
  },
  {
    type: "note",
    category: [`fsbo`],
    text: `Deposit should be held in eXp trust account or a lawyer's and NEVER 
    directly to the Seller.`,
  },
  {
    type: "note",
    category: [`fsbo`],
    text: `Ensure the deposit amount is enough to cover commission.`,
  },

  {
    type: "note",
    category: [`assignListing`, `assignPurchase`],
    text: `Agreements of Purchase and Sale are assignable by nature, unless
        otherwise specified. It's important to acquire the original purchase 
        agreement prior to listing to verify that the agreement is eligible for 
        assignment.`,
  },
  {
    type: "note",
    category: [`assignListing`, `assignPurchase`],
    text: `If it's a Pre-Con assignment, builders' consent is typically required,
    and so the builder consent clause should be included. In addition, it is always 
    recommended to have lawyer review conditions in the agreement as these
    can be complex transactions.`,
  },
  {
    type: "note",
    category: [`assignListing`, `assignPurchase`],
    text: `Have your clients obtain a lawyer that is both experienced and
    comfortable doing assignment agreements.`,
  },
  {
    type: "note",
    category: [`assignListing`],
    text: `It is important to check the original purchase contract or speak with
    the builder to find out if the property can be advertised (both MLS and public 
    websites).`,
  },
  {
    type: "note",
    category: [`assignPurchase`],
    text: `Thoroughly inspect the original purchase contract to understand the 
    specifics of the assignment for your client.`,
  },

  {
    type: "note",
    category: [`purchase`, `assignPurchase`],
    text: `<strong>FINTRAC Receipt of Funds:</strong> Required when deposit is
    going to a brokerage trust account. Typical situations when ROF is not
    required include when the deposit goes directly to a builder or lawyer's
    trust account.`,
  },
  {
    type: "note",
    category: [`purchase`, `assignPurchase`],
    text: `Ensure your Representation Agreement is signed on or before the start date of
    the agreement and before an offer is made.`,
  },
  {
    type: "note",
    category: [`purchase`, `assignPurchase`],
    text: `It is important to identify your Buyer clients before proceeding with 
    signing an agreement, to ensure the names on the agreement are correct and all 
    parties signing have the authority to do so.`,
  },
  {
    type: "note",
    category: [`mlsMeasure`],
    text: `<strong>RMS Measurements (Existing Structure):</strong> We require 
    the RMS measurement for the property, along with a Schematic that shows 
    the overall dimensions to show how the RMS was calculated. This does NOT 
    need to show rooms (but it can) as room measurements are not part of RMS.`,
  },
  {
    type: "note",
    category: [`mlsMeasure`],
    text: `<strong>RMS Measurements (New Builds):</strong> If the property has 
    not yet been built, the agent can submit the blueprints, with a statement 
    in the member remarks that the area size has been calculated by applying 
    the RMS to the blueprints provided by the builder. (There are 10 RMS 
    principles that the agent needs to review to ensure they are correctly 
    applied).`,
  },
  {
    type: "note",
    category: [`disclosure`],
    text: `<strong>Disclosure Requirements:</strong> If you have direct/indirect 
    interest in the property being listed then the following requirements are 
    as follows:
    <br/> <ol><li>Add type of interest into the private remarks on the MLS 
    Sheet. </li> 
    <li>Add a term in #16 of the ESRA with details of the interest. </li>
    <li>When a purchase agreement is written, it will also require a term to 
    disclose the agents interest.</li> </ol>`,
  },
  {
    type: "note",
    category: [`disclosurePurchase`],
    text: `<strong>Disclosure Requirements:</strong> If you have direct/indirect 
    interest in the transaction, whether direct or indirect, disclosure must 
    take place. Be sure to add the appropriate Disclosure Term in the Purchase 
    Contract. See the Common Situation Terms & Conditions Section on this page.
    </strong>`,
  },

  {
    type: "note",
    category: [`dowerListing`],
    text: `<strong>If Dower is applicable, the Dower must sign/complete:</strong> 
    <br/>
    <ol>
    <li>Purchase Contract Dower Consent and Acknowledgement signed by a 
    Commissioner for Oaths or Notary</li>
    <li>Check "YES" to both for 8.1 of the Listing Agreement.</li>
    <li>Dower Spouse ONLY signs at the bottom of the contract under Non-Owner 
    Spouse signature (Do not add as a Seller & do not initial contract).</li>
    <li>FINTRAC is NOT required for Dower Spouse.</li>
    </ol>`,
  },
  {
    type: "note",
    category: [`dowerPurchase`],
    text: `<strong>If Dower is applicable and you have an accepted agreement, 
    obtain/complete the following:</strong> 
    <br/>
    <ol>
    <li>Purchase Contract Dower Consent and Acknowledgement signed by a 
    Commissioner for Oaths or Notary (provided by listing agent)</li>
    <li>Insert Date in Section 7.1 stating when the Dower Form is to be provided</li>
    <li>Ensure Non-Owner Spouse Signature is in Section 18.1 of the Purchase Contract</li>
    </ol>`,
  },

  {
    type: "note",
    category: [`listing`],
    text: `<strong>Estate or Power of Attorney Listings:</strong> Please ensure the
    “Seller” name on the agreement reflects the individual(s) listed on
    title. If it is an estate, then put the Seller as: “The Estate of
    (deceased name).” If it is a Power of Attorney, "(Name on Title) by (attorney 
      name) under Power of Attorney." The supporting documents are required to prove 
      those
    signing the documents have the authority to do so. If enduring POA does not 
    come into effect until the doctor signs off, obtain a copy of the letter from 
    the doctor. For an estate, if probate has not yet been granted, a will and 
    death certificate is required.  For a POA, the POA document is required.`,
  },
  {
    type: "note",
    category: [`listing`],
    text: `<strong>Corporation Listing Requirements: </strong>
    <br/>
    <ol>
    <li>Corporate Search or Proof of Filing (must have been within 1 year)</li>
    <li>Complete FINTRAC for Corporation and FINTRAC ID for all directors that 
    are signing the documents.</li>
    <li>If there is more than one director and not all directors are signing 
    the documents or if a non-director is signing, a letter authorizing who 
    can bind the corporation is required.</li>
    </ol>`,
  },
  {
    type: "note",
    category: [`listing`],
    text: `It is important to identify your Seller clients before proceeding with
    signing an agreement to verify the names on the agreement are correct
    and all parties signing have the authority to do so.`,
  },
  {
    type: "note",
    category: [`listing`],
    text: `It is the responsibility of the listing agent to make sure that all 
    details on the listing are correct. Please verify all listing details.`,
  },

  {
    type: "note",
    category: [`referral`],
    text: ` <a
            href="https://drive.google.com/drive/folders/1i_gmDWWPJHZx8vbKUAnY-8U5C8l4Sdpi"
            target="_blank"
            rel="noreferrer"
          >
            Click here
          </a> 
          to access the Referral Agreements.`,
  },
  {
    type: "note",
    category: [`referral`],
    text: `For Referrals to Outside Brokerage Agents, create a Referral Transaction 
    in SkySlope once the deal is firm.`,
  },
  {
    type: "note",
    category: [`referral`],
    text: `Referrals or other payments must be paid through the brokerage.`,
  },

  {
    type: "note",
    category: [`purchase`, `assignPurchase`, `listing`],
    text: `“Time is of the essence” when it comes to agreements. Make sure that 
    agreements and related deal documents are signed within their designated time 
    frames to best protect your clients.`,
  },
  {
    type: "note",
    category: [`exclusiveListing`],
    text: `<strong>Exclusive Listings:</strong> In accordance with the REALTOR® Cooperation Policy, Members must, 
    within three (3) calendar days of any Public Marketing, place the Listing on 
    the MLS® System for cooperation with other REALTORS®. The following Listings 
    are exempt from the requirements above: rental, commercial, agricultural, and 
    new construction in developments with multiple units. See the following 
    link for more information: 
    <a href="https://www.CREA.ca/REALTORCooperation" target="_blank" rel="noopener noreferrer">CREA.ca/REALTORCooperation</a>`,
  },
];

export default importantNotes;
